import { render } from "./card-edit.vue?vue&type=template&id=ab098622&scoped=true"
import script from "./card-edit.vue?vue&type=script&lang=js"
export * from "./card-edit.vue?vue&type=script&lang=js"

import "./card-edit.vue?vue&type=style&index=0&id=ab098622&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab098622"]])

export default __exports__